jQuery(document).ready(function($) {
    // Flyout menu
    $('.open-flyout-menu').click(function() {
        $('.flyout-menu').addClass('show');
        $('.flyout-menu-background').addClass('show');
        $('body').addClass('overflow-hidden');
    });

    $('.close-flyout-menu, .flyout-menu-background').click(function() {
        $('.flyout-menu').removeClass('show');
        $('.flyout-menu-background').removeClass('show');
        $('body').removeClass('overflow-hidden');
    });

    // Flyout from right
    $('.open-flyout').click(function() {
        $('.flyout').addClass('show');
        $('.flyout-background').addClass('show');
        $('[id^="flyout-"]').hide(); // hide all elements with ID starting with "flyout-"
        $('#' + $(this).data("id") + '').show(); // show element with ID "flyout-1"
    });

    $('.close-flyout, .flyout-background').click(function() {
        $('.flyout').removeClass('show');
        $('.flyout-background').removeClass('show');
    });
});
//# sourceMappingURL=flyout.js.map
